import React, { useEffect, useState } from 'react';

import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';

import { accountsSelector } from '../../../account/account-selectors';
import { loadAccounts } from '../../../account/actions/load-accounts';

import { ACCOUNT_BULK_STATUS_CHANGE_COLUMNS } from '../../../accounts-list/accounts-list-columns';
import { AccountsListTable } from '../../../accounts-list/accounts-list-table';

import {
  AccountQueryParamFilters,
  AccountQueryParams,
  filterAccountsByQueryParams,
  validateAccountQueryParams,
} from './account-query-param-filters';
import { AccountTablePagination } from './account-table-pagination';

import { PENDING_ADMIN_ACTION } from '../../util/admin-web-routes';

export const BulkAccountStatusChanger = () => {
  const accounts = useSelector(accountsSelector, shallowEqual);
  const dispatch = useDispatch();
  const history = useHistory();

  const { search } = useLocation();
  const queryParams = validateAccountQueryParams(search);

  useEffect(() => {
    dispatch(loadAccounts());
  }, [dispatch]);

  const [offset, setOffset] = useState(0);

  const handleOffsetChange = (newOffset: number) => {
    setOffset(newOffset);
  };

  const navigateWithQueryStringParams = (updatedQueryParams: AccountQueryParams) => {
    history.replace(PENDING_ADMIN_ACTION('bulk-account-status-changer', updatedQueryParams));
  };

  const filteredAccounts = filterAccountsByQueryParams(queryParams, accounts);

  return (
    <div>
      <AccountQueryParamFilters navigateWithQueryStringParams={navigateWithQueryStringParams} />
      <AccountTablePagination
        count={filteredAccounts.length}
        offset={offset}
        handleOffsetChange={handleOffsetChange}
      />
      <AccountsListTable
        accounts={filteredAccounts}
        paginationOffset={offset}
        columns={ACCOUNT_BULK_STATUS_CHANGE_COLUMNS}
        navigateToAccountOnRowClick={false}
      />
      <AccountTablePagination
        count={filteredAccounts.length}
        offset={offset}
        handleOffsetChange={handleOffsetChange}
      />
    </div>
  );
};
